module.exports = __webpack_public_path__ + "media/bootstrap-icons/record-3027bc75.svg";